import { carContainerStatus } from "@/api/service";
import { LogHelper } from "@/common/LogHelper";


export const CarContainerStatus = (carCode, mac, devType) => {
    try {
        let status = "";
        let request = {
            devMac: mac,
            devType: devType,
            body: {
                queryValue: carCode,
                queryType: "32",
                viewType: "",
                extend1: "",
                extend2: "",
                extend3: "",
            },
        };
        debugger;
        var response = JSON.parse(carContainerStatus(JSON.stringify(request)));
        if (response.respcode == "000") {
            if (response.data.status != null) {
                status = response.data.status;
            }
        }
        return { status: status, resMsg: response.respMessage };
    } catch (ex) {
        LogHelper.WriteLog("车签状态查询接口异常" + ex.toString());
        return { status: null, resMsg: "车签状态查询接口异常！" };
    }

}